<ng-container>
  <!--Character Container-->
  <div class="ar-character-container">
    <div class="ar-character-header">
      <button class="ar-character-toggle" (click)="toggleCharacterExpanded()">
        Character {{ feature.characterExpanded ? '▼' : '▶' }}
      </button>
      <div class="ar-character-preview" *ngIf="!feature.characterExpanded">
        <span>Appearance:</span>
        <img [src]="getModelImagePath(feature.interactiveModel?.id)" class="ar-preview-image" alt="Character appearance" />
        <span>Voice:</span>
        <div class="ar-preview-voice">{{ feature.interactiveVoice.name }}</div>
      </div>
    </div>
  
    <div class="ar-character-details" [ngClass]="{'expanded': feature.characterExpanded}">
      <app-voice-selector class="ar-voice-selector"
        [voices]="voices" 
        [selectedVoice]="feature.interactiveVoice"
        [config]="config"
        (selectedVoiceChange)="feature.interactiveVoice = $event; onVoiceChange()">
      </app-voice-selector>
  
      <app-model-selector class="ar-model-selector"
        [models]="models" 
        [selectedModel]="feature.interactiveModel" 
        [modelFile]="feature.value.modelFile"
        [clientId]="clientId"
        [projectId]="projectId"
        (selectedModelChange)="feature.interactiveModel = $event; onModelChange()"
        (modelFileChange)="feature.value.modelFile = $event; onModelChange()">
      </app-model-selector>
    </div>
  </div>

  <!-- Scene Sequence - Single Instance -->
  <div class="shadow scene-sequence">
    <div>
      <button class="scene-sequence__title" [class.collapsed]="!feature.sceneExpanded" (click)="feature.sceneExpanded = !feature.sceneExpanded">
        Scene Sequence
      </button>
      <small class="scene-sequence__subtitle">Develop your scenario</small>
    </div>
    <div class="scene-sequence__content" [ngClass]="{'expanded': feature.sceneExpanded}">
      <div class="scene-sequence__tree">
        <app-scenario-tree 
          [feature]="feature" 
          [element]="feature.value.root"
          [animations]="animations" 
          [depth]="0"
          (elementSelected)="updateSelectedElement($event)">
        </app-scenario-tree>
      </div>
      <div class="scene-sequence__details">
        <app-scenario-details
          [feature]="feature"
          [element]="selectedElement"
          [animations]="animations"
          [clientId]="clientId"
          [projectId]="projectId"
          (elementChange)="onElementChange()">
        </app-scenario-details>
      </div>
    </div>
  </div>
</ng-container>